import { PackageEditorState } from './package-editor.state';
import { emptyPackage } from '../../constants/empty-package';
import { createReducer, on } from '@ngrx/store';
import {
    packageEditorLoadComplete,
    packageEditorLoadFailure,
    packageEditorLoadRequest,
    packageEditorNew, packageEditorSaveFailure, packageEditorSaveRequest, packageEditorSaveSuccess,
    packageEditorSetPackage
} from './package-editor.actions';

const initialState: PackageEditorState = {
    id: null,
    package: emptyPackage,
    loading: false,
    saving: false
};

const reducer = createReducer(
    initialState,
    on(packageEditorNew, () => (initialState)),
    on(packageEditorSetPackage, (state, { pkg } ) => ({ ...state, package: { ...state.package, ...pkg } })),
    on(packageEditorLoadRequest, (state) => ({ ...state, loading: true })),
    on(packageEditorLoadFailure, (state) => ({ ...state, loading: false })),
    on(packageEditorLoadComplete, (state, { pkg }) => ({ ...state, package: pkg, loading: false, id: pkg.id })),
    on(packageEditorSaveRequest, (state) => ({ ...state, saving: true })),
    on(packageEditorSaveSuccess, (state) => ({ ...state, saving: false })),
    on(packageEditorSaveFailure, (state) => ({ ...state, saving: false }))
);

export function packageEditorReducer(state: PackageEditorState | undefined, action: any): any {
    return reducer(state, action);
}
